import { getQuestionMsg } from "@/apis/question";
export default {
  namespaced: true,

  state: () => ({
    questionMsg: 0,
  }),

  mutations: {
    SET_QUESTION_MSG(state, count) {
      state.questionMsg = count;
    },
  },
  actions: {
    async fetchQuestionMsg({ commit }) {
      try {
        const res = await getQuestionMsg();
        if (res.errCode === 0) {
          commit("SET_QUESTION_MSG", res.data);
        } else {
          console.warn("获取未读消息失败：", res.msg);
        }
      } catch (error) {
        console.error("【API 请求异常】获取未读答疑消息失败：", error);
      }
    },

    /**
     * 可选：提供手动更新的方法（比如轮询或点击后刷新）
     */
    updateQuestionMsg({ dispatch }) {
      return dispatch("fetchQuestionMsg");
    },
  },

  getters: {
    questionMsg: (state) => state.questionMsg,
    hasNewMsg: (state) => state.questionMsg > 0,
  },
};
